import Header from 'scripts/components/modules/Header';
import layouts from 'scripts/util/layouts';

export default {
  init() {
    const components = {
      header: new Header(),
    };
    $('.fvAnchor').fvAnchor();
    $('.fvAccordion').fvAccordion();
  },
  finalize() {
    scrollToId();
  },
};

const scrollToId = () => {
  if (!window.location.hash || window.location.hash.length === 0) {
    return;
  }
  const id = window.location.hash.substring(window.location.hash.indexOf('#') + 1)
  if (id === '') {
    return;
  }
  const $target = $(`#${id}`);
  if ($target.length <= 0) {
    return;
  }
  $.Velocity($target, 'scroll', {
    duration: 0,
    offset: layouts.getHeaderOffset()
  });
}


// WEBPACK FOOTER //
// ./scripts/routes/common.js